<template>
    <div id="new_empleado">
        <h3>Nuevo empleado</h3>
        <div class="row">
            <form @submit.prevent = "guardarEmpleado" class="col s12"> 
                <div class="row">
                    <div class="input-field col s12">
                        <input type="text" v-model="empleado_id" required>
                        <label>ID del Empleado</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s12">
                        <input type="text" v-model="nombre" required>
                        <label>Nombre</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s12">
                        <input type="text" v-model="area" required>
                        <label>Area</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s12">
                        <input type="text" v-model="posicion" required>
                        <label>Posicion</label>
                    </div>
                </div>
                <button type="submit" class="btn">Enviar</button>
                <router-link to="/" class="btn grey">Cancelar</router-link>
            </form>
        </div>
    </div>
</template>
<script>
import db from './firebaseInit'
export default {
    name:'new-empleado',
    data(){
        return {
            empleado_id: null,
            nombre: null,
            area: null,
            posicion: null
        }
    },
    methods:{
        guardarEmpleado(){
            db.collection('empleados').add({
                empleado_id: this.empleado_id,
                nombre: this.nombre,
                area: this.area,
                posicion: this.posicion
            })
            //redireccion a la pag inicial
            .then(docRef =>  this.$router.push('/'))
            .catch(error => console.log(error))
        }
    }

}
</script>